// extracted by mini-css-extract-plugin
module.exports =  {"pf-textarea-autosize":"pf-textarea-autosize--g7sN8","pfTextareaAutosize":"pf-textarea-autosize--g7sN8"};